/**
 * 
 * Terminal
 * 
*/
export const updateTerminalStacksList = (terminalStacksList) => ({
  type: 'UPDATE_TERMINAL_STACKS_LIST',
  terminalStacksList,
});

export const updateTerminalHighlitedStackType = (terminalHighlitedStackType) => ({
  type: 'UPDATE_TERMINAL_HIGHLITED_STACK_TYPE',
  terminalHighlitedStackType,
});

export const updateTerminalLocationId = (terminalLocationId) => ({
  type: 'UPDATE_TERMINAL_LOCATION_ID',
  terminalLocationId,
});

export const updateTerminalComplectationId = (terminalComplectationId) => ({
  type: 'UPDATE_TERMINAL_COMPLECTATION_ID',
  terminalComplectationId,
});

export const updateTerminalTheme = (terminalTheme) => ({
  type: 'UPDATE_TERMINAL_THEME',
  terminalTheme,
});

export const updateTerminalRunline = (terminalRunline) => ({
  type: 'UPDATE_TERMINAL_RUNLINE',
  terminalRunline,
});

export const updateTerminalLogo = (terminalLogo) => ({
  type: 'UPDATE_TERMINAL_LOGO',
  terminalLogo,
});

export const updatePopupVisibility = (isPopupVisible) => ({
  type: 'UPDATE_POPUP_VISIBILITY',
  isPopupVisible,
});
